import {createApp} from "vue";
import App from "./App.vue";
import store from "@/store";
import router from "./router";
import i18n from "./i18n";

//Components
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

// UI
import "bootstrap";

// Styles
import "@/assets/layout/normalize.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/style.css";
import "@/assets/input.css";
import "@/assets/button.css";
import "@/assets/desktop.css";

const app = createApp(App);

app.component("DatePicker", DatePicker);
app.use(store);
app.use(router);
app.use(i18n);
app.mount("#app");
